export type Unsubscribe = () => void;

export class SimpleEmitter<TEvents extends Record<string, unknown>> {
  private listeners = new Map<keyof TEvents, Set<(payload: any) => void>>();

  on<K extends keyof TEvents>(event: K, cb: (payload: TEvents[K]) => void): Unsubscribe {
    const set = this.listeners.get(event) ?? new Set();
    set.add(cb as any);
    this.listeners.set(event, set);
    return () => set.delete(cb as any);
  }

  emit<K extends keyof TEvents>(event: K, payload: TEvents[K]) {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const cb of set) cb(payload);
  }
}

